import styled from 'styled-components';

export const Container = styled.div`
  .modal-body {
    align-items: center;
    .bodyText {
      align-self: center;
    }
    form {
      display: flex;
      width: 100%;

      div {
        margin-bottom: 0;
      }

      .buttonsContainer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        button {
          background: var(--green);
          border-radius: 9px;
          margin-right: 5px;

          &:hover {
            background: #5eb245;
          }

          color: #ffffff;
          font-weight: 600;

          width: 109px;
          height: 50px;
          margin-top: 20px;
          transition: background 0.3s ease;
          box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
            0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
        }

        .no {
          background: var(--white);
          color: black;

          &:hover {
            background: #dadada;
          }
        }
      }
    }
  }
`;

export const Title = styled.h1`
  text-align: left;
  font: normal normal bold 16px/20px IBM Plex Sans;
  letter-spacing: 0px;
  color: #075e89;
  opacity: 1;
  margin-left: 5px;
  margin-top: 25px;
`;
